import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 5.20053V2.8C2 2.58783 2.08429 2.38434 2.23431 2.23431C2.38434 2.08429 2.58783 2 2.8 2H5.2",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 5.20053V2.8C13.9998 2.58783 13.9155 2.38434 13.7655 2.23431C13.6155 2.08429 13.412 2 13.1998 2H10.7998",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 10.8V13.2C2 13.4122 2.08429 13.6156 2.23431 13.7657C2.38434 13.9157 2.58783 14 2.8 14H5.2",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 10.8V13.2C13.9998 13.4122 13.9155 13.6156 13.7655 13.7657C13.6155 13.9157 13.412 14 13.1998 14H10.7998",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFit;
